import { Injectable } from '@angular/core';

@Injectable()

export class TestingDataService {
  private _data: any;
  private _bitchClicked: boolean = false;

  constructor() { }

  set data(value: any) {
    this._data = value;
  }

  get data(): any {
    return this._data;
  }

  get bitchClicked(): boolean {
    return this._bitchClicked;
  }

  set bitchClicked(value: boolean) {
    this._bitchClicked = value;
  }
}


// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/testing-page/testing.service.ts